import { render, staticRenderFns } from "./contratosRenovacaoSidebar.vue?vue&type=template&id=6e62ff7b"
import script from "./contratosRenovacaoSidebar.vue?vue&type=script&lang=js"
export * from "./contratosRenovacaoSidebar.vue?vue&type=script&lang=js"
import style0 from "./contratosRenovacaoSidebar.vue?vue&type=style&index=0&id=6e62ff7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports